// extracted by mini-css-extract-plugin
export default {"smartphoneInvitationSection":"ThankYouContainer-module_smartphoneInvitationSection_ZnPdXzS3HH"};